export default __webpack_public_path__ + "static/media/icon2.7c7636dc.svg";